import { useContext, useEffect, useRef, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import StatusContext from "../../../../contexts/status.js";
import ToastContext from "../../../../contexts/toast.js";
import { PlessoService } from "../../../../services/PlessoService.js";
import { RichiestaService } from "../../../../services/RichiestaService.js";
import Input from "../../../Form/Input.js";
import Radio from "../../../Form/Radio.js";
import Select from "../../../Form/Select";
import Checkbox from "../../../Form/Checkbox";
import AlertMessage from "../../../Utility/Alert/AlertMessage.js";
import { FormUtility } from "../../../Utility/FormUtility.js";
import tuttiComuni from "../../../Utility/json/tuttiComuni.js";
import Modal from "../../../Utility/Modal/Modal.js";

const Step4IscrizioneScolasticaRipresentazione = (props) => {
    const scrollRef = useRef(null);
    const formRef = useRef(null);
    const [dirty, setDirty] = useState(false);
    const toastContext = useContext(ToastContext);
    const { id } = useParams();
    const [inSave, setInSave] = useState(false);
    const [inputErrors, setInputErrors] = useState([]);
    const [init, setInit] = useState(false);
    const richiesta = props.richiesta;
    const richiestaOriginale = { ...richiesta };
    const [richiestaDatiBeneficiario, setRichiestaDatiBeneficiario] = useState({ ...richiesta.richiestaDatiBeneficiario });
    const [richiestaIscrizioneScolastica, setRichiestaIscrizioneScolastica] = useState({ ...richiesta.richiestaIscrizioneScolastica });
    const [richiestaDatiPagamento, setRichiestaDatiPagamento] = useState({ ...richiesta.richiestaDatiPagamento });
    const [validate, setValidate] = useState(false);
    const statusContext = useContext(StatusContext);

    const [isModalOpen, setModalOpen] = useState(false);
    const [title, setTitle] = useState(null);
    const [content, setContent] = useState(null);
    const [icon, setIcon] = useState(false);
    const [hideCloseButton, setHideCloseButton] = useState(false);
    const [actionLabel, setActionLabel] = useState(false);
    const navigate = useNavigate();
    const [iconaClass, setIconaClass] = useState(null);
    const [iconaColorClass, setIconaColorClass] = useState(null);
    const [saveDone, setSaveDone] = useState(false);

    const nextBtnFunction = props.nextBtnFunction;
    const previousBtnFunction = props.previousBtnFunction;
    const afterSubmitFunction = props.afterSubmitFunction;

    const [condizioniStudente, setCondizioniStudente] = useState(null);
    const ordini = [
        { key: "MEDIA", value: "Scuola secondaria di primo grado (scuola media)" },
        {
            key: "SUPERIORE",
            value: "Scuola secondaria di secondo grado (scuola superiore)",
        },
    ];
    const [anniCorso, setAnniCorso] = useState([]);
    const regioni = [
        { key: "Emilia-Romagna", value: "Emilia Romagna" },
        { key: "Lazio", value: "Lazio" },
        { key: "Liguria", value: "Liguria" },
        { key: "Marche", value: "Marche" },
        { key: "Umbria", value: "Umbria" },
    ];
    const [comuni, setComuni] = useState([]);
    const [comuniScuola, setComuniScuola] = useState([]);
    const [plessi, setPlessi] = useState([]);
    const [indirizziDiStudio, setIndirizziDiStudio] = useState([]);

    const [loadingPlessi, setLoadingPlessi] = useState(false);

    const richiestaService = new RichiestaService();
    const plessoService = new PlessoService();

    const utility = new FormUtility();

    useEffect(() => {
        const comuniScuola = [...tuttiComuni]
            .filter(
                (el) =>
                    el.denominazione_regione === "Toscana" &&
                    el.data_fine_validita === null
            )
            .sort((a, b) => a.denominazione.localeCompare(b.denominazione));
        setComuniScuola(comuniScuola);

        return () => {
            statusContext.removeEvent("onbeforeunload");
            setDirty(false);
        };
    }, []);

    useEffect(() => {
        if (!richiesta || init) return;

        if (richiesta.richiestaIscrizioneScolastica?.ordineGrado) {
            onChangeOrdineGrado(
                { target: { value: richiesta.richiestaIscrizioneScolastica.ordineGrado } },
                richiesta,
                richiesta.richiestaIscrizioneScolastica,
                false
            );
        }

        if (richiesta.richiestaIscrizioneScolastica?.regioneScuolaFuoriToscana) {
            onChangeRegione(
                {
                    target: {
                        value:
                            richiesta.richiestaIscrizioneScolastica.regioneScuolaFuoriToscana,
                    },
                },
                false,
                false
            );
        }

        setCondizioniStudente([
            {
                key: "AMMESSO",
                value:
                    "Ammesso alla classe successiva per l’A.S. " +
                    richiesta.bando.annoEducativo +
                    " (promosso)",
            },
            {
                key: "NON_AMMESSO",
                value:
                    "Non ammesso alla classe successiva per l’A.S. " +
                    richiesta.bando.annoEducativo +
                    " (respinto)",
            },
            {
                key: "SOSPENSIONE_DEL_GIUDIZIO",
                value:
                    "Sospensione del giudizio per debito/i formativo/i fino a settembre " +
                    utility.ottieniPrimaParteAnnoEducativo(richiesta.bando.annoEducativo) +
                    " (rimandato)"
            },
            {
                key: "MOBILITA_FORMATIVA",
                value:
                    "Mobilità formativa (in attesa di sostenere la prova di esame di rientro dall'estero)",
            },
            {
                key: "STATO_PROVVISORIO",
                value:
                    "Stato provvisorio di non conoscenza dell'esito degli scrutini di fine A.S. " +
                    utility.ottieniAnnoPrecedente(richiesta.bando.annoEducativo) +
                    " o dell'esame di stato"
            },
            {
                key: "ATTESA_ASSEGNAZIONE",
                value:
                    "In attesa di assegnazione dell'istituto/tipologia di scuola"
            }
        ]);

        setInit(true);
    }, [richiesta, init]);

    const onNextBtnClick = (e) => {
        if (e) {
            e.preventDefault();
            e.stopPropagation();
        }
        if (nextBtnFunction) nextBtnFunction();
    }

    const onPrevBtnClick = (e) => {
        if (e) {
            e.preventDefault();
            e.stopPropagation();
        }
        if (nextBtnFunction) previousBtnFunction();
    }

    const setFormErrors = (setFocus = true) => {
        const errors = utility.getAllInputErrors(formRef);
        setInputErrors(errors.map((el) => el.id));
        if (setFocus && errors.length > 0) {
            errors[0].focus();
        }
    };

    const onModifiedData = (updateFormErrors = true, updateDirty = true) => {
        if (updateFormErrors) {
            setTimeout(() => {
                setFormErrors(false);
            }, 0);
        }

        if (updateDirty) {
            statusContext.addEvent("onbeforeunload");
            setDirty(true);
        }
    };

    const previousAnnoEducativo = (annoEducativo) => {
        if (!annoEducativo) {
            return "";
        }

        const [anno1, anno2] = annoEducativo.split("/");
        const annoPrecedente = `${parseInt(anno1) - 1}/${parseInt(anno2) - 1}`;
        return annoPrecedente;
    };

    const onChangeValue = async (event, field = "value", targetName = null) => {
        const target = event.target;
        const name = targetName ?? target.name;
        const value = target[field];
        setDirty(true);
        if (name === "condizioneStudente") {
            setRichiestaDatiBeneficiario({
                ...richiestaOriginale.richiestaDatiBeneficiario,
            });
            setRichiestaIscrizioneScolastica({
                ...richiestaOriginale.richiestaIscrizioneScolastica,
                [name]: value,
                istitutoInToscana: null,
                cambioIstitutoTipologia: null,
                scuolaFuoriToscana: null,
                codiceScuolaFuoriToscana: null,
                denominazioneScuolaFuoriToscana: null,
                comune: null,
                comuneFuoriToscanaId: null,
                indirizzoScuolaFuoriToscana: null,
                scuola: null,
                plesso: null,
                ordineGrado:null,
                annoCorso:null

            });
            setRichiestaDatiPagamento({
                ...richiestaOriginale.richiestaDatiPagamento,
            });
        } else if (["nome", "cognome", "cittadinanza"].includes(name)) {
            richiestaDatiBeneficiario[name] = value;
            setRichiestaDatiBeneficiario({ ...richiestaDatiBeneficiario });
        } else if (
            [
                "scuolaFuoriToscana",
                "codiceScuolaFuoriToscana",
                "denominazioneScuolaFuoriToscana",
                "comune",
                "comuneFuoriToscanaId",
                "annoCorso",
                "indirizzoDiStudio",
                "indirizzoScuolaFuoriToscana"
            ].includes(name)
        ) {
            richiestaIscrizioneScolastica[name] = value;
            setRichiestaIscrizioneScolastica({ ...richiestaIscrizioneScolastica });
        } else if (name === "denominazioneBanca") {
            richiestaDatiPagamento[name] = value;
            setRichiestaDatiPagamento({ ...richiestaDatiPagamento });
        }

        onModifiedData(validate);
    };

    const salvaStep = async (event) => {
        event.preventDefault();
        event.stopPropagation();

        setValidate(true);

        const validity = formRef.current.checkValidity();

        if (!validity) {
            setFormErrors();
            return;
        }

        setInputErrors([]);

        if (!dirty) {
            onNextBtnClick();
            return;
        }

        setInSave(true);

        const body = {
            condizioneStudente: richiestaIscrizioneScolastica.condizioneStudente,
            cambioIstitutoTipologia:
                richiestaIscrizioneScolastica.cambioIstitutoTipologia,
            ordineGrado: richiestaIscrizioneScolastica.ordineGrado,
            annoCorso: richiestaIscrizioneScolastica.annoCorso,
            istitutoInToscana: richiestaIscrizioneScolastica.istitutoInToscana,
            confermaComunicazioneAssegnazione:richiestaIscrizioneScolastica.confermaComunicazioneAssegnazione,
            comune: comuni.find(
                (c) =>
                    c.id ===
                    parseInt(
                        richiestaIscrizioneScolastica.istitutoInToscana === false
                            ? richiestaIscrizioneScolastica.comuneFuoriToscanaId
                            : richiestaIscrizioneScolastica.comune?.id ||
                            richiestaIscrizioneScolastica.comune
                    )
            ),
            scuola: plessi.find(
                (p) =>
                    p.id ===
                    parseInt(
                        richiestaIscrizioneScolastica.scuola ||
                        richiestaIscrizioneScolastica.plesso?.id
                    )
            ),
            indirizzoDiStudio: indirizziDiStudio.find(
                (iid) =>
                    iid.id ===
                    parseInt(
                        richiestaIscrizioneScolastica.indirizzoDiStudio?.id ||
                        richiestaIscrizioneScolastica.indirizzoDiStudio
                    )
            ),
            regioneScuolaFuoriToscana:
                !richiestaIscrizioneScolastica.istitutoInToscana
                    ? richiestaIscrizioneScolastica.regioneScuolaFuoriToscana
                    : null,
            codiceScuolaFuoriToscana:
                !richiestaIscrizioneScolastica.istitutoInToscana
                    ? richiestaIscrizioneScolastica.codiceScuolaFuoriToscana
                    : null,
            denominazioneScuolaFuoriToscana:
                !richiestaIscrizioneScolastica.istitutoInToscana
                    ? richiestaIscrizioneScolastica.denominazioneScuolaFuoriToscana
                    : null,
            indirizzoScuolaFuoriToscana:
                !richiestaIscrizioneScolastica.istitutoInToscana ?
                    richiestaIscrizioneScolastica.indirizzoScuolaFuoriToscana : null
        };

        richiestaService.salvaStep4Riapertura(richiesta.id, body).then(result => {
            if (afterSubmitFunction) {
                afterSubmitFunction(result);
                toastContext.success("Dati salvati", 6000);
                console.log("step4 ", result);
                setInSave(false);
                setDirty(false);
                onNextBtnClick(null);
            }
        }).catch((err) => {
            toastContext.error(utility.getErrorMsg(err), 2000);
            console.log(err);
            setInSave(false);
        });
    };

    const handleModalAction = async () => {
        console.log("handleModalAction");
        if (!saveDone) {
            setInSave(true);

            setInputErrors([]);

            const body = {
                condizioneStudente: richiestaIscrizioneScolastica.condizioneStudente,
                cambioIstitutoTipologia:
                    richiestaIscrizioneScolastica.cambioIstitutoTipologia,
                ordineGrado: richiestaIscrizioneScolastica.ordineGrado,
                annoCorso: richiestaIscrizioneScolastica.annoCorso,
                istitutoInToscana: richiestaIscrizioneScolastica.istitutoInToscana,
                comune: comuni.find(
                    (c) =>
                        c.id ===
                        parseInt(
                            richiestaIscrizioneScolastica.istitutoInToscana === false
                                ? richiestaIscrizioneScolastica.comuneFuoriToscanaId
                                : richiestaIscrizioneScolastica.comune?.id ||
                                richiestaIscrizioneScolastica.comune
                        )
                ),
                scuola: plessi.find(
                    (p) =>
                        p.id ===
                        parseInt(
                            richiestaIscrizioneScolastica.scuola ||
                            richiestaIscrizioneScolastica.plesso?.id
                        )
                ),
                indirizzoDiStudio: indirizziDiStudio.find(
                    (iid) =>
                        iid.id ===
                        parseInt(
                            richiestaIscrizioneScolastica.indirizzoDiStudio?.id ||
                            richiestaIscrizioneScolastica.indirizzoDiStudio
                        )
                ),
                regioneScuolaFuoriToscana:
                    !richiestaIscrizioneScolastica.istitutoInToscana
                        ? richiestaIscrizioneScolastica.regioneScuolaFuoriToscana
                        : null,
                codiceScuolaFuoriToscana:
                    !richiestaIscrizioneScolastica.istitutoInToscana
                        ? richiestaIscrizioneScolastica.codiceScuolaFuoriToscana
                        : null,
                denominazioneScuolaFuoriToscana:
                    !richiestaIscrizioneScolastica.istitutoInToscana
                        ? richiestaIscrizioneScolastica.denominazioneScuolaFuoriToscana
                        : null,
                indirizzoScuolaFuoriToscana:
                    !richiestaIscrizioneScolastica.istitutoInToscana
                        ? richiestaIscrizioneScolastica.indirizzoScuolaFuoriToscana
                        : null,
            };

            alert(JSON.stringify(body));

            richiestaService
                .salvaStep4Riapertura(id, body)
                .then(() => {
                    setHideCloseButton(true);
                    setInSave(false)
                    const msg = "Dati aggiornati con successo";
                    toastContext.success(msg);
                    statusContext.removeEvent("onbeforeunload");

                    setDirty(false);
                    setActionLabel("Chiudi");
                    setTitle("Domanda aggiornata!");
                    setIcon(true);
                    setIconaClass("solid--check-circle");
                    setIconaColorClass("rtds-text-success-dark");
                    setContent(
                        `La domanda con codice '${richiesta.codice}'. è stata aggiornata correttamente. A seguito dei controlli verrà inviata un’e-mail di conferma dell'aggiornamento.`
                    );
                    setModalOpen(true);
                    setSaveDone(true);
                })
                .catch((err) => {
                    toastContext.error(utility.getErrorMsg(err), 2500);
                    setInSave(false);
                    setModalOpen(false);
                });
        } else {
            navigate("/dashboard");
        }
    };

    const onChangeRadioButtonValue = (checked, field) => {
        setDirty(true);
        switch (field) {
            case "modificaDatiPagamento":
                setRichiestaDatiPagamento({
                    ...richiestaOriginale.richiestaDatiPagamento,
                    [field]: checked,
                });
                setRichiestaDatiBeneficiario({
                    ...richiestaOriginale.richiestaDatiBeneficiario,
                });
                break;
            case "cambioIstitutoTipologia":
                setRichiestaIscrizioneScolastica({
                    ...richiestaOriginale.richiestaIscrizioneScolastica,
                    [field]: checked,
                    condizioneStudente: richiestaIscrizioneScolastica.condizioneStudente
                });
                break;
            case "istitutoInToscana":
                setRichiestaIscrizioneScolastica({
                    ...richiestaOriginale.richiestaIscrizioneScolastica,
                    [field]: checked,
                    condizioneStudente: richiestaIscrizioneScolastica.condizioneStudente,
                    cambioIstitutoTipologia:
                        richiestaIscrizioneScolastica.cambioIstitutoTipologia,
                    ordineGrado: richiestaIscrizioneScolastica.ordineGrado,
                    annoCorso: richiestaIscrizioneScolastica.annoCorso
                });
                break;
            default:
                break;
        }

        onModifiedData(validate);
    };

    const onChangeOrdineGrado = async (
        event,
        richiesta,
        richiestaIscrizioneScolastica,
        updateDirty = true
    ) => {
        if (updateDirty) {
            setDirty(true);
        }
        const value = event.target.value;
        richiestaIscrizioneScolastica.ordineGrado = value;
        if (!richiestaIscrizioneScolastica.ordineGrado) {
            richiestaIscrizioneScolastica.annoCorso = null;
            richiestaIscrizioneScolastica.comune = null;
            richiestaIscrizioneScolastica.plesso = null;
            richiestaIscrizioneScolastica.scuola = null;
            richiestaIscrizioneScolastica.indirizzoDiStudio = null;
            richiestaIscrizioneScolastica.comuneFuoriToscanaId = null;
            richiestaIscrizioneScolastica.scuolaFuoriToscana = null;
            richiestaIscrizioneScolastica.codiceScuolaFuoriToscana = null;
            setRichiestaIscrizioneScolastica({ ...richiestaIscrizioneScolastica });
            onModifiedData(validate, updateDirty);
            return;
        }

        if (updateDirty) {
            setRichiestaIscrizioneScolastica({
                ...richiestaIscrizioneScolastica,
                comune: null,
                plesso: null,
                scuola: null,
                indirizzoDiStudio: null,
                comuneFuoriToscanaId: null,
                scuolaFuoriToscana: null,
                codiceScuolaFuoriToscana: null,
            });
        }

        const options =
            value === "MEDIA"
                ? [
                    { key: 1, label: "1° anno" },
                    { key: 2, label: "2° anno" },
                    { key: 3, label: "3° anno" },
                ]
                : [
                    { key: 1, label: "1° anno" },
                    { key: 2, label: "2° anno" },
                    { key: 3, label: "3° anno" },
                    { key: 4, label: "4° anno" },
                    { key: 5, label: "5° anno" },
                    { key: 6, label: "6° anno" },
                ];

        setAnniCorso(options);

        const comune = [...tuttiComuni].find(
            (c) =>
                c.id ===
                parseInt(
                    richiestaIscrizioneScolastica?.comune?.id ||
                    richiestaIscrizioneScolastica?.comune
                )
        );
        let plexes;
        if (comune) {
            plexes = await getPlessiByBandoIdAndComuneId(
                richiesta,
                richiestaIscrizioneScolastica,
                comune.id,
                comune.denominazione
            );
        }
        if (
            !updateDirty &&
            (richiestaIscrizioneScolastica.plesso?.id ||
                richiestaIscrizioneScolastica.scuola)
        ) {
            onChangeScuola(
                {
                    target: {
                        value:
                            richiestaIscrizioneScolastica.plesso?.id ??
                            richiestaIscrizioneScolastica.scuola,
                    },
                },
                richiestaIscrizioneScolastica,
                plexes,
                updateDirty
            );
        }

        onModifiedData(validate, updateDirty);
    };

    const onChangeScuola = (
        event,
        richiestaIscrizioneScolastica,
        plessi,
        updateDirty = true
    ) => {
        if (updateDirty)
            setDirty(true);
        const target = event.target;
        const value = target.value;

        richiestaIscrizioneScolastica.scuola = value;
        setRichiestaIscrizioneScolastica({ ...richiestaIscrizioneScolastica });

        setIndirizziDiStudio(
            plessi.find((p) => p.id === parseInt(value))?.indirizzi || []
        );

        onModifiedData(validate, updateDirty);
    };

    const getPlessiByBandoIdAndComuneId = async (
        richiesta,
        richiestaIscrizioneScolastica,
        comuneId,
        comuneDenominazione
    ) => {
        setLoadingPlessi(true);

        let resp = await plessoService.getAllByBandoIdAndComuneId(
            richiesta.bando.id,
            comuneId
        );
        const isSuperiore =
            richiestaIscrizioneScolastica.ordineGrado === "SUPERIORE";
        resp = resp
            ?.filter((plesso) =>
                isSuperiore
                    ? plesso.indirizzi.length > 0
                    : plesso.indirizzi.length === 0
            )
            .map((el) => ({ ...el, label: `${el.denominazione} [${el.codice}]` }))
            .sort((a, b) => (a?.denominazione > b?.denominazione ? 1 : -1));

        setPlessi(resp);
        setLoadingPlessi(false);

        if (resp.length === 0) {
            toastContext.warning(
                `Non sono presenti scuole di ${richiestaIscrizioneScolastica.ordineGrado === "SUPERIORE"
                    ? "Secondo"
                    : "Primo"
                }  grado nel comune di ${comuneDenominazione}`
            );
        }

        return resp;
    };

    const onChangeRegione = (event, toUpdate = true, updateDirty = true) => {
        if (updateDirty) {
            setDirty(true);
        }
        const target = event.target;
        const value = target.value;

        if (toUpdate) {
            richiestaIscrizioneScolastica.regioneScuolaFuoriToscana = value;
            setRichiestaIscrizioneScolastica({ ...richiestaIscrizioneScolastica });
        }

        const comuni = [...tuttiComuni].filter(
            (el) => el.denominazione_regione === value
        );
        setComuni([...comuni]);

        onModifiedData(validate, toUpdate);
    };

    const onChangeComuneScuola = (event, field) => {
        setDirty(true);
        const target = event.target;
        const value = target.value;

        richiestaIscrizioneScolastica[field] = value;
        setRichiestaIscrizioneScolastica({ ...richiestaIscrizioneScolastica });

        const comune = comuniScuola.find((c) => c.id === parseInt(value));
        if (comune) {
            getPlessiByBandoIdAndComuneId(
                richiesta,
                richiestaIscrizioneScolastica,
                comune.id,
                comune.denominazione
            );
        }

        setIndirizziDiStudio([]);

        onModifiedData(validate);
    };


    const onChangeConfermaAssegnazione = (value) => {

        if (value === null) return;
        setDirty(true);
        setRichiestaIscrizioneScolastica({ ...richiestaIscrizioneScolastica, confermaComunicazioneAssegnazione: value });
        onModifiedData(validate);
    }


    const getInfoCondizioneStudente = (condizione) => {
        return 'Confermo che lo studente è iscritto a una scuola secondaria di primo grado (scuola media) o secondo grado (scuola superiore) e mi impegno a comunicare al prossimo accesso classe/istituto/scuola a cui è iscritto per l\'a.s. ' + richiesta?.bando?.annoEducativo + ', secondo la procedura esposta nell\'Avviso Libri Gratis';        
    }

    return (
        <>
            <div className="rtds-container rtds-my-12" ref={scrollRef}>
                <div
                    key={5}
                    id={`tabpanel-5`}
                    className="rtds-tablist__tabpanel"
                    role="tabpanel"
                    aria-labelledby={`tab-5`}
                >
                    <div className=" rtds-my-12 ">
                        <div className="rtds-mb-6">
                            <h1 className="rtds-text-2xl rtds-font-bold">
                                {`Dati sull'iscrizione scolastica`}
                            </h1>
                        </div>
                        <div className="rtds-background-01 rtds-p-6 rtds-border rtds-border-gray-02">
                            <div className="rtds-pb-6 rtds-space-y-4 rtds-border-b rtds-border-gray-02">
                                <p>
                                    I campi obbligatori sono contrassegnati da un
                                    asterisco&nbsp;
                                    <abbr
                                        className="rtds-font-bold rtds-no-underline"
                                        title="obbligatorio"
                                    >
                                        *
                                    </abbr>
                                </p>
                            </div>

                            <form
                                noValidate
                                ref={formRef}
                                id="hasValidationFor"
                                className="has-js-validation-form rtds-py-6 rtds-space-y-4"
                            >
                                <h2 className="rtds-text-xl rtds-font-bold">
                                    Dichiarazioni ed esito
                                </h2>

                                <div className="rtds-field-row ">
                                    <Select
                                        classDiv={"rtds-mt-3 lg:rtds-mt-0"}
                                        label={
                                            "Condizione dello studente alla chiusura dell'A.S. " +
                                            previousAnnoEducativo(richiesta?.bando?.annoEducativo)
                                        }
                                        required
                                        id={"condizioneStudente"}
                                        inputErrors={inputErrors}
                                        classSelect={"rtds-overflow-hidden text-ellipsis rtds-whitespace-nowrap rtds-w-full rtds-pr-7"}
                                        onChange={(event) =>
                                            onChangeValue(event, "value", "condizioneStudente")
                                        }
                                        baseOption={"Seleziona Condizione"}
                                        options={condizioniStudente}
                                        bindKey={"key"}
                                        bindValue={"value"}
                                        value={
                                            richiestaIscrizioneScolastica.condizioneStudente || ""
                                        }
                                        aria-describedby="span_info_codizione"
                                    />
                                </div>

                                <div className="rtds-horizontal-divider rtds-border-b rtds-border-gray-03 rtds-mt-3 rtds-mb-4 "></div>

                                <h2 className="rtds-text-xl rtds-font-bold">
                                    Informazioni sulla scuola che frequenterà lo studente
                                    beneficiario nell'anno scolastico{" "}
                                    {richiesta?.bando?.annoEducativo}
                                </h2>
                                <AlertMessage
                                    message={
                                        "Compila attentamente questa sezione, se indichi una scuola o classe di frequenza errata per l'A.S. " +
                                        richiesta?.bando?.annoEducativo +
                                        ", potresti ricevere un contributo inferiore e non avrai diritto a richiedere la differenza in un secondo momento oppure potresti essere soggetta/o a revoca come stabilito dall’Avviso Libri Gratis."
                                    }
                                    iconName="mini--information-circle"
                                    title="Attenzione!"
                                    classArticle="rtds-mb-6"
                                />

                                {!(
                                    richiestaIscrizioneScolastica.condizioneStudente ===
                                    "SOSPENSIONE_DEL_GIUDIZIO" ||
                                    richiestaIscrizioneScolastica.condizioneStudente ===
                                    "MOBILITA_FORMATIVA" ||
                                    richiestaIscrizioneScolastica.condizioneStudente ===
                                    "STATO_PROVVISORIO" 
                                ) && (

                                <div className="rtds-field-row">
                                    <Select
                                        classDiv={"rtds-mt-3 lg:rtds-mt-0"}
                                        label={"Ordine e grado"}
                                        id={"ordineGrado"}
                                        classSelect={""}
                                        onChange={(event) =>
                                            onChangeOrdineGrado(
                                                event,
                                                richiesta,
                                                richiestaIscrizioneScolastica,
                                            )
                                        }
                                        baseOption={"Nessuna selezione"}
                                        options={ordini}
                                        bindValue={"value"}
                                        bindKey={"key"}
                                        value={richiestaIscrizioneScolastica.ordineGrado || ""}
                                        inputErrors={inputErrors}
                                        required
                                    />

                                    <Select
                                        classDiv={"rtds-mt-3 lg:rtds-mt-0"}
                                        label={
                                            "Anno di corso (classe a.s. " +
                                            richiesta?.bando?.annoEducativo +
                                            ")"
                                        }
                                        id={"annoCorso"}
                                        classSelect={""}
                                        onChange={(event) =>
                                            onChangeValue(event, "value", "annoCorso")
                                        }
                                        baseOption={"Nessuna selezione"}
                                        bindKey={"key"}
                                        bindValue={"label"}
                                        options={anniCorso}
                                        disabled={!richiestaIscrizioneScolastica.ordineGrado}
                                        value={richiestaIscrizioneScolastica.annoCorso || ""}
                                        inputErrors={inputErrors}
                                        required
                                    />
                                </div>
                                )}

                                {!(
                                    richiestaIscrizioneScolastica.condizioneStudente ===
                                    "SOSPENSIONE_DEL_GIUDIZIO" ||
                                    richiestaIscrizioneScolastica.condizioneStudente ===
                                    "MOBILITA_FORMATIVA" ||
                                    richiestaIscrizioneScolastica.condizioneStudente ===
                                    "STATO_PROVVISORIO" ||
                                    richiestaIscrizioneScolastica.condizioneStudente ===
                                    "ATTESA_ASSEGNAZIONE"
                                ) && (
                                        <div className="rtds-field-row">
                                            <div className="">
                                                <fieldset className="rtds-input-field rtds-gap-2">
                                                    <legend className="rtds-input-field__label">
                                                        L'istituto scolastico ha sede in Toscana?&nbsp;
                                                        <abbr
                                                            className="rtds-font-bold rtds-no-underline"
                                                            title="obbligatorio"
                                                        >
                                                            *
                                                        </abbr>
                                                    </legend>

                                                    <Radio
                                                        classDiv={"rtds-input-radio rtds-input--lg"}
                                                        label={"Sì"}
                                                        value="true"
                                                        id={"istitutoInToscanaSi"}
                                                        name="istitutoInToscana"
                                                        classInput={""}
                                                        onChange={() =>
                                                            onChangeRadioButtonValue(
                                                                true,
                                                                "istitutoInToscana",
                                                            )
                                                        }
                                                        checked={
                                                            richiestaIscrizioneScolastica.istitutoInToscana ===
                                                            true
                                                        }
                                                    ></Radio>
                                                    <Radio
                                                        classDiv={"rtds-input-radio rtds-input--lg"}
                                                        label={"No"}
                                                        value="false"
                                                        id={"istitutoInToscanaNo"}
                                                        name="istitutoInToscana"
                                                        classInput={""}
                                                        onChange={() =>
                                                            onChangeRadioButtonValue(
                                                                false,
                                                                "istitutoInToscana",
                                                            )
                                                        }
                                                        checked={
                                                            richiestaIscrizioneScolastica.istitutoInToscana ===
                                                            false
                                                        }
                                                        inputErrors={inputErrors}
                                                        required={
                                                            richiestaIscrizioneScolastica.istitutoInToscana ===
                                                            undefined ||
                                                            richiestaIscrizioneScolastica.istitutoInToscana ===
                                                            null
                                                        }
                                                    ></Radio>
                                                </fieldset>
                                            </div>
                                        </div>
                                    )}
                                {!(
                                    richiestaIscrizioneScolastica.condizioneStudente ===
                                    "SOSPENSIONE_DEL_GIUDIZIO" ||
                                    richiestaIscrizioneScolastica.condizioneStudente ===
                                    "MOBILITA_FORMATIVA" ||
                                    richiestaIscrizioneScolastica.condizioneStudente ===
                                    "STATO_PROVVISORIO" ||
                                    richiestaIscrizioneScolastica.condizioneStudente ===
                                    "ATTESA_ASSEGNAZIONE"
                                ) &&
                                    richiestaIscrizioneScolastica.istitutoInToscana && (
                                        <>
                                            <div className="rtds-field-row">
                                                <Select
                                                    classDiv={"rtds-mt-3 lg:rtds-mt-0"}
                                                    label={"Comune della scuola"}
                                                    id={"comune"}
                                                    classSelect={""}
                                                    onChange={(event) =>
                                                        onChangeComuneScuola(event, "comune")
                                                    }
                                                    baseOption={"Nessuna selezione"}
                                                    options={comuniScuola}
                                                    bindKey={"id"}
                                                    bindValue={"denominazione"}
                                                    value={
                                                        richiestaIscrizioneScolastica.comune?.id ||
                                                        richiestaIscrizioneScolastica.comune ||
                                                        ""
                                                    }
                                                    inputErrors={inputErrors}
                                                    disabled={
                                                        !richiestaIscrizioneScolastica.ordineGrado
                                                    }
                                                    required
                                                />

                                                <Select
                                                    classDiv={"rtds-mt-3 lg:rtds-mt-0"}
                                                    label={"Scuola"}
                                                    id={"scuola"}
                                                    classSelect={""}
                                                    onChange={(event) =>
                                                        onChangeScuola(
                                                            event,
                                                            richiestaIscrizioneScolastica,
                                                            plessi,
                                                        )
                                                    }
                                                    baseOption={"Nessuna selezione"}
                                                    bindKey={"id"}
                                                    bindValue={"label"}
                                                    options={plessi}
                                                    value={
                                                        richiestaIscrizioneScolastica?.scuola ||
                                                        richiestaIscrizioneScolastica.plesso?.id ||
                                                        ""
                                                    }
                                                    inputErrors={inputErrors}
                                                    required
                                                    disabled={
                                                        !richiestaIscrizioneScolastica.ordineGrado ||
                                                        !richiestaIscrizioneScolastica.comune ||
                                                        loadingPlessi
                                                    }
                                                />

                                                <Select
                                                    classDiv={"rtds-mt-3 lg:rtds-mt-0"}
                                                    label={"Indirizzo di studio"}
                                                    id={"indirizzoDiStudio"}
                                                    classSelect={""}
                                                    onChange={(event) =>
                                                        onChangeValue(event, "value", "indirizzoDiStudio")
                                                    }
                                                    baseOption={"Nessuna selezione"}
                                                    bindKey={"id"}
                                                    bindValue={"denominazione"}
                                                    options={indirizziDiStudio}
                                                    value={
                                                        richiestaIscrizioneScolastica.indirizzoDiStudio
                                                            ?.id ||
                                                        richiestaIscrizioneScolastica?.indirizzoDiStudio ||
                                                        ""
                                                    }
                                                    inputErrors={inputErrors}
                                                    required={
                                                        richiestaIscrizioneScolastica?.ordineGrado !==
                                                        "MEDIA"
                                                    }
                                                    disabled={
                                                        !richiestaIscrizioneScolastica.ordineGrado ||
                                                        !richiestaIscrizioneScolastica?.scuola
                                                    }
                                                    hidden={
                                                        richiestaIscrizioneScolastica?.ordineGrado ===
                                                        "MEDIA"
                                                    }
                                                />
                                            </div>
                                        </>
                                    )}

                                {!(
                                    richiestaIscrizioneScolastica.condizioneStudente ===
                                    "SOSPENSIONE_DEL_GIUDIZIO" ||
                                    richiestaIscrizioneScolastica.condizioneStudente ===
                                    "MOBILITA_FORMATIVA" ||
                                    richiestaIscrizioneScolastica.condizioneStudente ===
                                    "STATO_PROVVISORIO" ||
                                    richiestaIscrizioneScolastica.condizioneStudente ===
                                    "ATTESA_ASSEGNAZIONE"
                                ) &&
                                    richiestaIscrizioneScolastica.istitutoInToscana ===
                                    false && (
                                        <>
                                            <div className="rtds-field-row">
                                                <Select
                                                    classDiv={"rtds-mt-3 lg:rtds-mt-0"}
                                                    label={"Regione della scuola"}
                                                    id={"regioneScuolaFuoriToscana"}
                                                    classSelect={""}
                                                    onChange={(event) => onChangeRegione(event)}
                                                    baseOption={"Nessuna selezione"}
                                                    options={regioni}
                                                    bindValue={"value"}
                                                    bindKey={"key"}
                                                    value={
                                                        richiestaIscrizioneScolastica.regioneScuolaFuoriToscana ||
                                                        ""
                                                    }
                                                    inputErrors={inputErrors}
                                                    required
                                                />

                                                <Select
                                                    classDiv={"rtds-mt-3 lg:rtds-mt-0"}
                                                    label={"Comune della scuola"}
                                                    id={"comuneScuolaFuoriToscana"}
                                                    classSelect={""}
                                                    onChange={(event) =>
                                                        onChangeValue(
                                                            event,
                                                            "value",
                                                            "comuneFuoriToscanaId",
                                                        )
                                                    }
                                                    baseOption={"Nessuna selezione"}
                                                    bindKey={"id"}
                                                    bindValue={"denominazione"}
                                                    options={comuni}
                                                    value={
                                                        richiestaIscrizioneScolastica.comuneFuoriToscanaId ||
                                                        ""
                                                    }
                                                    inputErrors={inputErrors}
                                                    required={
                                                        !!richiestaIscrizioneScolastica.regioneScuolaFuoriToscana
                                                    }
                                                    disabled={
                                                        !richiestaIscrizioneScolastica.regioneScuolaFuoriToscana
                                                    }
                                                />
                                            </div>

                                            <div className="rtds-field-row">
                                                <Input
                                                    classDiv={"rtds-mt-3 lg:rtds-mt-0"}
                                                    label={"Codice meccanografico della scuola"}
                                                    id={"codiceScuolaFuoriToscana"}
                                                    classInput={"rtds-text-sm rtds-input-placeholder"}
                                                    type={"text"}
                                                    onChange={(event) =>
                                                        onChangeValue(
                                                            event,
                                                            "value",
                                                            "codiceScuolaFuoriToscana",
                                                        )
                                                    }
                                                    value={
                                                        richiestaIscrizioneScolastica.codiceScuolaFuoriToscana ||
                                                        ""
                                                    }
                                                    inputErrors={inputErrors}
                                                    required
                                                    maxLength={10}
                                                    minLength={10}
                                                />
                                                <Input
                                                    classDiv={"rtds-mt-3 lg:rtds-mt-0"}
                                                    label={"Denominazione della scuola"}
                                                    id={"denominazioneScuolaFuoriToscana"}
                                                    classInput={"rtds-text-sm rtds-input-placeholder"}
                                                    type={"text"}
                                                    onChange={(event) =>
                                                        onChangeValue(
                                                            event,
                                                            "value",
                                                            "denominazioneScuolaFuoriToscana",
                                                        )
                                                    }
                                                    value={
                                                        richiestaIscrizioneScolastica.denominazioneScuolaFuoriToscana ||
                                                        ""
                                                    }
                                                    inputErrors={inputErrors}
                                                    required
                                                    maxLength={255}
                                                />
                                                <Input
                                                    classDiv={"rtds-mt-3 lg:rtds-mt-0"}
                                                    label={"Indirizzo della scuola"}
                                                    id={"indirizzoScuolaFuoriToscana"}
                                                    classInput={"rtds-text-sm rtds-input-placeholder"}
                                                    type={"text"}
                                                    onChange={(event) =>
                                                        onChangeValue(
                                                            event,
                                                            "value",
                                                            "indirizzoScuolaFuoriToscana",
                                                        )
                                                    }
                                                    value={
                                                        richiestaIscrizioneScolastica.indirizzoScuolaFuoriToscana ||
                                                        ""
                                                    }
                                                    inputErrors={inputErrors}
                                                    required
                                                    maxLength={255}
                                                />
                                            </div>
                                        </>
                                    )}

                                {(richiestaIscrizioneScolastica.condizioneStudente ===
                                    "SOSPENSIONE_DEL_GIUDIZIO" ||
                                    richiestaIscrizioneScolastica.condizioneStudente ===
                                    "MOBILITA_FORMATIVA" ||
                                    richiestaIscrizioneScolastica.condizioneStudente ===
                                    "STATO_PROVVISORIO" ||
                                    richiestaIscrizioneScolastica.condizioneStudente ===
                                    "ATTESA_ASSEGNAZIONE") && (

                                        <Checkbox
                                            classDiv={'rtds-input-checkbox rtds-input--lg'}
                                            id={'confermaComunicazioneAssegnazione'}
                                            label={getInfoCondizioneStudente(richiestaIscrizioneScolastica.condizioneStudente)}
                                            inputErrors={inputErrors}
                                            classInput={''}
                                            onChange={(event) => { onChangeConfermaAssegnazione(event.target.checked); }}
                                            checked={richiestaIscrizioneScolastica?.confermaComunicazioneAssegnazione || false}
                                            required
                                        />
                                    )}

                                <div className="rtds-border-gray-02 rtds-border-b rtds-border-t rtds-p-3 rtds-flex sm:justify-end justify-center">
                                    <div className="rtds-form-actions">
                                        <div
                                            className="rtds-inline-flex rtds-gap-1"
                                            role="group"
                                            aria-label="Ruolo"
                                        >
                                            <button
                                                onClick={onPrevBtnClick}
                                                type="button"
                                                className="rtds-btn rtds-btn--secondary rtds-btn--icon-left rtds-group/button rtds-form-submit"
                                                disabled={inSave}
                                            >
                                                <svg
                                                    className="rtds-icon rtds-fill-current rtds-w-4 rtds-h-4 md:rtds-w-5 md:rtds-h-5 lg:rtds-w-6 lg:rtds-h-6  group-hover/button:-rtds-translate-x-1"
                                                    aria-hidden="true"
                                                    focusable="false"
                                                    role="img"
                                                >
                                                    <use
                                                        xlinkHref={`${process.env.PUBLIC_URL}/icons.svg#solid--arrow-uturn-left`}
                                                    />
                                                </svg>{" "}
                                                Indietro
                                            </button>
                                            <button
                                                type="button"
                                                className="rtds-btn rtds-btn--primary rtds-form-submit rtds-btn--icon-right rtds-group/button"
                                                onClick={salvaStep}
                                                disabled={inSave}
                                            >
                                                Salva
                                                <span className="lg:sx-diplay-none">
                                                    {" "}
                                                    e vai avanti
                                                </span>
                                                {inSave ? (
                                                    <>
                                                        <svg
                                                            className="rtds-icon rtds-fill-current rtds-w-4 rtds-h-4 rtds-animate-spin md:rtds-w-5 md:rtds-h-5 lg:rtds-w-6 lg:rtds-h-6"
                                                            aria-hidden="true"
                                                            focusable="false"
                                                            role="img"
                                                        >
                                                            <use
                                                                xlinkHref={`${process.env.PUBLIC_URL}/icons.svg#spinner`}
                                                            />
                                                        </svg>
                                                        <span className="rtds-sr-only">
                                                            Caricamento...
                                                        </span>
                                                    </>
                                                ) : (
                                                    <>
                                                        <svg
                                                            className="rtds-icon rtds-fill-current rtds-w-4 rtds-h-4 md:rtds-w-5 md:rtds-h-5 lg:rtds-w-6 lg:rtds-h-6 group-hover/button:rtds-translate-x-1"
                                                            aria-hidden="true"
                                                            focusable="false"
                                                            role="img"
                                                        >
                                                            <use
                                                                xlinkHref={`${process.env.PUBLIC_URL}/icons.svg#mini--chevron-right`}
                                                            />
                                                        </svg>
                                                    </>
                                                )}
                                            </button>
                                        </div>
                                    </div>
                                </div>
                            </form>
                        </div>
                    </div>
                </div>
                <Modal
                    isOpen={isModalOpen}
                    title={title}
                    content={content}
                    onAction={handleModalAction}
                    actionLabel={actionLabel}
                    closeLabel="Annulla"
                    hideCloseButton={hideCloseButton}
                    icona={icon}
                    iconaClass={iconaClass}
                    iconaColorClass={iconaColorClass}
                    onClose={() => setModalOpen(false)}
                    disabledConfirmBtn={inSave}
                    disableCloseBtn={inSave}
                />
            </div>
        </>
    );
};

export default Step4IscrizioneScolasticaRipresentazione;
